class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    // SAFETY CHECK
    if (!this.mainDetailsToggle) {
      console.warn('No <details> found inside', this);
      return;
    }

    this.summary = this.mainDetailsToggle.querySelector('summary');

    // SAFETY CHECK
    if (!this.summary) {
      console.warn('No <summary> found inside', this.mainDetailsToggle);
      return;
    }

    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      'toggle',
      this.onToggle.bind(this)
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onToggle() {
    // SAFETY CHECK
    if (!this.content) return;

    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    // SAFETY CHECK
    if (!this.mainDetailsToggle || !this.summary) return;

    this.mainDetailsToggle.removeAttribute('open');

    this.summary.setAttribute(
      'aria-expanded',
      false
    );
  }
}

customElements.define(
  'details-disclosure',
  DetailsDisclosure
);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    // Prevent parent crash
    if (!this.mainDetailsToggle || !this.header) return;

    this.header.preventHide =
      this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    ) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(
        this.header.getBoundingClientRect().bottom
      )}px`
    );
  }
}

customElements.define(
  'header-menu',
  HeaderMenu
);